export class RouteConstants {
	public static PAGES = '/';
	public static LOGIN = 'login';
	public static HOME = 'home';
	public static DASHBOARD = 'home/dashboard';
	public static REPORTS = 'home/reports';
	public static ANALYTICAL_DASHBOARD = 'home/analyticalDashboard';
}
